import {styled} from '@volkswagen-onehub/components-core';
import React from 'react';
import {getTranslations} from '../translations';
import {VehicleInterface} from '@vw-marketing/vw-ca-types';

interface DealershipMovedInterface {
  dealer: VehicleInterface['dealer_info'];
}

const DealershipMovedContainer = styled.div``;

const DealershipMoved: React.FC<DealershipMovedInterface> = ({dealer}) => {
  const {labels} = getTranslations();

  return (
    <DealershipMovedContainer>
      {labels.dealershipMoved} {dealer.fullname}
    </DealershipMovedContainer>
  );
};

export default DealershipMoved;
